import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import { APP_ROUTES } from '../shared/config/routes-config';
import type { RouteConfig } from '../shared/interfaces/routes-config.interface';
import { STAFF_LIST_ROLES } from '../shared/config/staff-roles.config';
import { UserManagementListContainer } from './user-management-list/userManagement.container';
import { UserAccountsListContainer } from './user-accounts-list/userAccountsList.container';
import { UserManagementCreateContainer } from './user-management-create/userManagementCreate.container';

const children = APP_ROUTES.USER_MANAGEMENT_MODULE.CHILDREN as RouteConfig;

const StaffList: React.FC = () => (
  <UserAccountsListContainer
    roles={STAFF_LIST_ROLES}
    title="Staff Users"
    createPath={children.STAFF_CREATE.FULL_PATH}
    createLabel="Create staff user"
    exportName="staff-users"
  />
);

const StaffCreate: React.FC = () => (
  <UserManagementCreateContainer returnPath={children.STAFF.FULL_PATH} />
);

/**
 * function UserManagementModule components
 */
export const UserManagementModule: React.FC = () => {
  return (
    <Switch>
      {/* Create first — /staff would otherwise swallow /staff/create. */}
      <Route exact path={children.STAFF_CREATE.FULL_PATH} component={StaffCreate} />
      <Route path={children.STAFF.FULL_PATH} component={StaffList} />
      <Route path={children.GUESTS.FULL_PATH} component={UserManagementListContainer} />
      {/* The old flat paths, so links and bookmarks still land somewhere sensible. */}
      <Redirect exact from="/user-management/search" to={children.GUESTS.FULL_PATH} />
      <Redirect exact from="/user-management/create" to={children.STAFF_CREATE.FULL_PATH} />
      <Redirect to={children.GUESTS.FULL_PATH} />
    </Switch>
  );
};
